export const CompliantContractAbi = [
	{
		"inputs": [],
		"name": "compliance",
		"outputs": [
			{
				"internalType": "contract ICompliance",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];

export default CompliantContractAbi;
